module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3eMQD"))).then(() => parcelRequire('37nVf'));